import { render, staticRenderFns } from "./construction.vue?vue&type=template&id=483cd570&"
import script from "./construction.vue?vue&type=script&lang=js&"
export * from "./construction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports